"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashBody = exports.TransactionBase = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
const common_1 = require("../common");
const encoding_1 = require("../encoding");
const enums_gen_1 = require("./enums_gen");
class TransactionBase {
    hash() {
        if (this._hash)
            return this._hash;
        if (!this.header)
            throw new Error(`invalid transaction: missing header`);
        if (!this.body)
            throw new Error(`invalid transaction: missing body`);
        this._hash = (0, common_1.sha256)(common_1.Buffer.concat([(0, common_1.sha256)((0, encoding_1.encode)(this.header)), hashBody(this.body)]));
        return this._hash;
    }
}
exports.TransactionBase = TransactionBase;
function hashBody(body) {
    switch (body.type) {
        case enums_gen_1.TransactionType.WriteData:
        case enums_gen_1.TransactionType.WriteDataTo:
        case enums_gen_1.TransactionType.SyntheticWriteData:
        case enums_gen_1.TransactionType.SystemWriteData: {
            if (!body.entry)
                throw new Error(`invalid ${body.type}: missing entry`);
            if (!body.entry.data)
                throw new Error(`invalid ${body.type}: missing entry data`);
            const copy = body.copy();
            delete copy.entry;
            const withoutEntry = (0, common_1.sha256)((0, encoding_1.encode)(copy));
            const entryHash = body.entry.hash();
            return (0, common_1.sha256)(common_1.Buffer.concat([withoutEntry, entryHash]));
        }
        default:
            return (0, common_1.sha256)((0, encoding_1.encode)(body));
    }
}
exports.hashBody = hashBody;
//# sourceMappingURL=base.js.map